import { preventEvent } from "./element";

export const isIe = () => {
  var agent = navigator.userAgent.toLowerCase();
  return (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || (agent.indexOf("msie") !== -1);
};

export const isMobile = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

export const newWindow = (url, e) => {
  preventEvent(e);
  window.open(url, "_blank");
};

export const clipboardCopy = (text, placeholder = '', isAlert = true) => {
  const tempInput = document.createElement('input');
  tempInput.value = text;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand('copy');
  document.body.removeChild(tempInput);
  // eslint-disable-next-line no-alert
  isAlert && alert(placeholder || `"${text}"가 복사되었습니다.`);
};
export const textAreaClipboardCopy = (text, placeholder = '', isAlert = true) => {
  const tempInput = document.createElement('textarea');
  tempInput.value = text;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand('copy');
  document.body.removeChild(tempInput);
  // eslint-disable-next-line no-alert
  isAlert && alert(placeholder || `"${text}"가 복사되었습니다.`);
};
